import $ from 'jquery';// MktoForms2 (Marketo) dependency

/**
 * 
 */
class MktoFormLoader {
    constructor(host, munchkinId, formId) {
        this.host = host;
        this.munchkinId = munchkinId;
        this.formId = formId;

        this.target = undefined;
        this.translation = {};
        this.additionalFields = [];

        this.form = undefined;

        // this.overwriteMkto2Form();
    }

    legacyFormInit() {

    }

    overwriteMkto2Form() {
        console.log('MktoFormLoader.overwriteMkto2Form()');

        var MktoForms2newForm = MktoForms2.newForm;

        MktoForms2.newForm = function(formData, callback) {
            console.log('MktoForms2.newForm(formData, callback) [formData]', formData);

            formData = this.processFormDescriptor(formData);

            MktoForms2newForm(formData, callback);
        }
    }

    setNode(selector) {
        console.log('MktoFormLoader.setNode(selector) [selector]', selector);

        let target = document.querySelector(selector);

        if (target) {
            this.target = target;
        }

        return this;
    }

    addTranslation(translation) {
        console.log('MktoFormLoader.addTranslation(translation) [translation]', translation);

        this.translation = translation;

        return this;
    }

    addFields(additionalFields) {
        console.log('MktoFormLoader.addFields(additionalFields) [additionalFields]', additionalFields);

        if (Array.isArray(additionalFields)) {
            this.additionalFields = additionalFields;
        }
        
        return this;
    }

    loadForm() {
        var self = this,
            MktoForms2newForm = MktoForms2.newForm;

        MktoForms2.newForm = function(formData, callback) {
            console.log('MktoForms2.newForm(formData, callback) [formData, callback]', formData, callback);

            formData = self.processFormDescriptor(formData);

            MktoForms2newForm(formData, (form) => {
                var formRender = form.render;

                form.render = function() {
                    formRender(self.target && $(self.target));
                };

                if (callback) {
                   callback(form);
                }
            });
        };
        
        return new Promise((resolve, reject) => {
            MktoForms2.loadForm(this.host, this.munchkinId, this.formId, (form) => {
                MktoForms2.newForm = MktoForms2newForm;
                resolve(form);
            });
        });
    }

    processFormDescriptor(formDescriptor) {
        console.log('MktoFormLoader.processFormDescriptor() [formDescriptor]', formDescriptor);

        let fieldsToAdd = [];
        this.additionalFields.forEach(function(additionalField) {
            let matchedField = false;

            formDescriptor.rows.forEach(function(row, rowIndex) {
                row.forEach(function(originalField, fieldIndex) {
                    if (additionalField['Name'] === originalField['Name']) {
                        formDescriptor.rows[rowIndex][fieldIndex] = additionalField;
                        matchedField = true;
                    }
                });
            });

            if (!matchedField) {
                fieldsToAdd.push(additionalField);
            }
        });

        formDescriptor.rows.unshift(fieldsToAdd);



        if (this.translation) {
            if (this.translation[formDescriptor.SubmitLabel]) {
                formDescriptor.SubmitLabel = this.translation[formDescriptor.SubmitLabel];
            }
            
            for (let i = 0, max = formDescriptor.rows.length; i < max; i++) {
                let row = formDescriptor.rows[i];

                for (let j = 0, maxj = row.length; j < maxj; j++) {
                    let input = row[j],
                        picklistValues = input.PicklistValues || [];

                    if (this.translation[input.InputLabel]) {
                        input.InputLabel = this.translation[input.InputLabel];
                    }

                    if (this.translation[input.PlaceholderText]) {
                        input.PlaceholderText = this.translation[input.PlaceholderText];
                    }

                    if (this.translation[input.Description]) {
                        input.Description = this.translation[input.Description];
                    }

                    if (this.translation[input.ValidationMessage]) {
                        input.ValidationMessage = this.translation[input.ValidationMessage];
                    }

                    for (let k = 0, maxk = picklistValues.length; k < maxk; k++) {
                        let picklistValue = picklistValues[k];

                        if (this.translation[picklistValue.label]) {
                            picklistValue.label = this.translation[picklistValue.label];
                        }
                    }

                    if (['consentToProcessing', 'consenttoProcessing', 'consentToMarketing', 'consenttoMarketing', 'Consent_to_Marketing_Capture__c'].includes(input.Name) && this.translation[input.Name]) {
                        input.InputLabel = this.translation[input.Name];
                        input.PicklistValues[0]['label'] = this.translation[input.Name];
                    }

                    if (this.translation[input.Htmltext]) {
                        input.Htmltext = this.translation[input.Htmltext];
                    }
                }
            }
        }

        return formDescriptor;
    }

    static getFieldsForSegment(segmentName, fieldDescriptors) {
        console.log('MktoFormLoader.getFieldsForSegment(segmentName, fieldDescriptors) [segmentName, fieldDescriptors]', segmentName, fieldDescriptors);

        let fields = {};

        if (fieldDescriptors['DEFAULT'] && fieldDescriptors['DEFAULT']['fields']) {
            fieldDescriptors['DEFAULT']['fields'].forEach(field => {
                fields[field['Name']] = field;
            });
        }

        if (!fieldDescriptors[segmentName]) {
            return Object.values(fields);
        }

        if (fieldDescriptors[segmentName]['TEMPLATE']) {
            this.getFieldsForSegment(fieldDescriptors[segmentName]['TEMPLATE'], fieldDescriptors).forEach(field => {
                fields[field['Name']] = field;
            });
        }

        if (fieldDescriptors[segmentName]['fields']) {
            fieldDescriptors[segmentName]['fields'].forEach(field => {
                fields[field['Name']] = field;
            });
        }

        return Object.values(fields);
    }
}


export default MktoFormLoader;

